
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';

const advantages = [
  { text: 'Evidence-based design with clinical backing' },
  { text: 'Crisis-safe AI with human support' },
  { text: 'Working MVP ready for deployment' },
  { text: 'Comprehensive multi-pronged solution' },
  { text: 'Scalable architecture ready for schools' },
];

const CompetitiveAdvantages = () => {
  return (
    <AdvantagesSection id="advantages">
      <Container>
        <SectionHeading>Why MindBridge Wins</SectionHeading>
        <AdvantagesList>
          {advantages.map((advantage, index) => (
            <AdvantageItem key={index}>
              <CheckIcon />
              <span>{advantage.text}</span>
            </AdvantageItem>
          ))}
        </AdvantagesList>
      </Container>
    </AdvantagesSection>
  );
};

export default CompetitiveAdvantages;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
`;

const AdvantagesSection = styled.section`
  background-color: var(--background-dark);
`;

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionHeading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 4rem;
  color: var(--primary-blue-dark);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const AdvantagesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const AdvantageItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
  opacity: 0;
  animation: ${fadeIn} 0.5s ease-out forwards;

  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
  &:nth-child(5) { animation-delay: 0.5s; }

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const CheckIcon = styled(FaCheckCircle)`
  color: var(--secondary-green);
  font-size: 1.8rem;
  margin-right: 1rem;
  flex-shrink: 0;
`;
